import { render, staticRenderFns } from "./QuestionarioFinaleGrid.vue?vue&type=template&id=dd461858&scoped=true"
import script from "./QuestionarioFinaleGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionarioFinaleGrid.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuestionarioFinaleGrid.vue?vue&type=style&index=0&id=dd461858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd461858",
  null
  
)

export default component.exports